module.exports = __webpack_public_path__ + "static/media/badge_shuxue.72ee1a48.svg";